import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { fetcher, IError } from 'utils/fetchers'

const apiUrl = `${API_BASE_URL}/provinces`

interface Province {
  id: number
  countryId: number
  title: string
}

type Provinces = Province[]

export function useFetchProvinces() {
  const { data, error } = useSWR<Provinces, IError | null>(`${apiUrl}`, fetcher)
  return {
    provinces: data,
    isLoading: !error && !data,
    isError: !!error,
    error: error,
  }
}
